import React from 'react';
import TemplatesList from '../components/Settings/Templates/TemplatesList';

function TemplatesListRoute(props) {
  return <TemplatesList {...props} />;
}

export default TemplatesListRoute;
